import { render } from "./reportHistoryDetails.vue?vue&type=template&id=03a36570"
import script from "./reportHistoryDetails.vue?vue&type=script&lang=js"
export * from "./reportHistoryDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__